import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isMarketingRoute } from "@/lib/marketing-routes";

/**
 * Stamps `data-surface="marketing"` on <html> for the public pages.
 *
 * The draft is set in General Sans, but the logged-in product is set in Inter
 * and has never been reviewed against the draft — so the typeface is switched
 * by route rather than globally, and `index.css` keys off this attribute.
 * Renders nothing.
 */
export default function MarketingSurface() {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    if (isMarketingRoute(pathname)) {
      root.dataset.surface = "marketing";
    } else {
      delete root.dataset.surface;
    }
    return () => {
      delete root.dataset.surface;
    };
  }, [pathname]);

  return null;
}
